import { render, staticRenderFns } from "./StudyBanner.vue?vue&type=template&id=3300637b&scoped=true"
import script from "./StudyBanner.vue?vue&type=script&lang=js"
export * from "./StudyBanner.vue?vue&type=script&lang=js"
import style0 from "./StudyBanner.vue?vue&type=style&index=0&id=3300637b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300637b",
  null
  
)

export default component.exports